import { render } from "./pdf-module.vue?vue&type=template&id=24816b00"
import script from "./pdf-module.vue?vue&type=script&lang=js"
export * from "./pdf-module.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__